import React from "react";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import { ListSubheader } from "@mui/material";

const AnalysisTargetSelect = ({
    user,
    analysisTarget,
    setAnalysisTarget,
    setInterventionResponse,
    setIsCalculated,
    teamsApi,
    setIsTeam,
    setIsOrg,
    setSelectedId,
}) => {
    const handleTargetChange = (event) => {
        setAnalysisTarget(event.target.value);
    };

    return (
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
            <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={analysisTarget}
                onChange={handleTargetChange}
                renderValue={(selected) => (
                    <Typography variant="body1" sx={{ fontSize: "14px", marginTop: "2px" }}>
                        {selected}
                    </Typography>
                )}
            >
                <ListSubheader style={{ lineHeight: "32px" }}>User</ListSubheader>
                <MenuItem
                    value="yourself"
                    sx={{ fontSize: "14px" }}
                    onClick={() => {
                        setIsTeam(false);
                        setIsOrg(false);
                        setSelectedId(user.id);
                        setInterventionResponse(undefined);
                        setIsCalculated(false);
                    }}
                >
                    yourself
                </MenuItem>
                <ListSubheader style={{ lineHeight: "32px" }}>Organization</ListSubheader>
                <MenuItem
                    value="your organization"
                    sx={{ fontSize: "14px" }}
                    onClick={() => {
                        setIsTeam(false);
                        setIsOrg(true);
                        setSelectedId(user.orgId);
                        setInterventionResponse(undefined);
                        setIsCalculated(false);
                    }}
                >
                    your organization
                </MenuItem>
                <ListSubheader style={{ lineHeight: "32px" }}>Teams</ListSubheader>
                {teamsApi &&
                    teamsApi.status === "SUCCESS" &&
                    teamsApi.data.map((team) => {
                        return (
                            <MenuItem
                                key={team.id}
                                value={team.name}
                                sx={{ fontSize: "14px" }}
                                onClick={() => {
                                    setIsTeam(true);
                                    setIsOrg(false);
                                    setSelectedId(team.id);
                                    setInterventionResponse(undefined);
                                    setIsCalculated(false);
                                }}
                            >
                                {team.name}
                            </MenuItem>
                        );
                    })}
            </Select>
        </FormControl>
    );
};

export default AnalysisTargetSelect;
